export default defineNuxtRouteMiddleware(async (to) => {
	// Skip role check during SSR
	if (import.meta.server) {
		return
	}

	const requiredRole = to.meta.role
	if (requiredRole == null) {
		return
	}

	const { hasRole } = useUserContext()

	if (!hasRole(requiredRole)) {
		return navigateTo("/forbidden")
	}
})
